/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { IoMdPerson } from "react-icons/io";
import instance from "../../api/api";
import { Loader } from "../../components/Loader";
import { ToggleSwitch } from "flowbite-react";
import UploadCSV from "../../components/UploadCSV";

function AdminProfile() {
  const [departments, setDepartments] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [existingUser, setExistingUser] = useState();
  const [updatedUser, setUpdatedUser] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [pageError, setPageError] = useState();
  const [isUpdating, setIsUpdating] = useState(false);
  const [isToastVisible, setIsToastVisible] = useState(false);
  const [currentDepartment, setCurrentDepartment] = useState("");

  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const getExistingUser = async () => {
      console.log("this is the user id: ", userId);
      setIsLoading(true);
        try {
            const response = await instance.get(`/api/admin/users/user/${userId}`);
            setExistingUser(response.data.data);
            setIsLoading(false);
            console.log(response.data.data)
        } catch (error) {
          setIsLoading(false)
            console.error(error);
        }
    }

    const getAllDepartments = async () => {
      try {
        const response = await instance.get("/api/departments/all");
        console.log(response.data.data);
        setDepartments(response.data.data)
      } catch (error) {
        
        console.error(error);
      }
    };

    

    getExistingUser();
    getAllDepartments();
  }, [userId]);

  const handleUpdateSuccess = () => {
    // Logic for signup success
    setIsToastVisible(true);

    // Hide the toast after a few seconds
    setTimeout(() => {
      setIsToastVisible(false);
    }, 10000); // Adjust the timeout duration as needed
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setIsUpdating(true);
    console.log("This is the updated user: ", updatedUser)
    try {
      await instance.put(`/api/admin/users/user/update/${existingUser.id}`, updatedUser)
      handleUpdateSuccess();
      setIsUpdating(false)
    } catch (error) {
      setPageError(error.response.data.message);
      setIsUpdating(false)
      return error
    }
  };
  return (
    <div className="">
      <h2 className="text-2xl font-medium">Profile Settings</h2>
      {isToastVisible && (
          <div
            id="toast-success"
            className="fixed top-15 left-1/2 transform -translate-x-1/2 flex items-center w-full max-w-xs p-4 mb-4 text-gray-500 bg-white rounded-lg shadow dark:text-gray-400 dark:bg-gray-800"
            role="alert"
          >
            <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-green-500 bg-green-100 rounded-lg dark:bg-green-800 dark:text-green-200">
              <svg
                class="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
              </svg>
              <span class="sr-only">Check icon</span>
            </div>
            <div class="ms-3 text-sm font-normal">Profile Updated</div>
            <button
              type="button"
              class="ms-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex items-center justify-center h-8 w-8 dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700"
              data-dismiss-target="#toast-success"
              aria-label="Close"
            >
              <span class="sr-only">Close</span>
              <svg
                class="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
            </button>
          </div>
        )}
      
      {isLoading ? (
        <div className="flex justify-center items-center h-96 border-2 border-dashed mt-5 p-5 pl-20 rounded-lg dark:text-white">
          <Loader />
          </div>
      ) : (<div className="flex justify-between border-2 border-dashed mt-5 p-5 pl-20 rounded-lg dark:text-white">
        
        {/* Image div */}
        <div className="p-10">
          <div className="border-2 rounded-full p-4">
            <IoMdPerson size={100} />
          </div>
        </div>

        {/* form div */}
        <div className="w-full p-10">
          <form onSubmit={handleUpdateProfile}>
            <div className="flex gap-8 pb-10">
                <p>Administrator Status</p>
                <span><ToggleSwitch checked={true} disabled label="This user is an admin" onChange={() => undefined} /></span>
            </div>
            <div className="grid md:grid-cols-2 md:gap-6">
              <div className="relative z-0 w-full mb-5 group">
                <label
                  htmlFor="firstname"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  First Name
                </label>
                <input
                  type="text"
                  id="firstName"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-caribbeanCurrent focus:border-caribbeanCurrent block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-caribbeanCurrent dark:focus:border-caribbeanCurrent"
                  placeholder="Enter first name"
                  name="firstName"
                  defaultValue={existingUser && existingUser.firstName ? existingUser.firstName : ""}
                  onChange={(e) => {
                    setUpdatedUser((prevState) => ({
                      ...prevState,
                      firstName: e.target.value,
                    }));
                  }}
                  // onChange={handleSignupChange}
                />
              </div>
              <div className="relative z-0 w-full mb-5 group">
                <label
                  htmlFor="lastName"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Last Name
                </label>
                <input
                  type="text"
                  id="lastname"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-caribbeanCurrent focus:border-caribbeanCurrent block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-caribbeanCurrent dark:focus:border-caribbeanCurrent"
                  placeholder="Enter last name"
                  name="lastName"
                  defaultValue={existingUser && existingUser.lastName ? existingUser.lastName : ""}
                  onChange={(e) => {
                    setUpdatedUser((prevState) => ({
                      ...prevState,
                      lastName: e.target.value,
                    }));
                  }}
                  // onChange={handleSignupChange}
                />
              </div>
            </div>
            <div className="relative z-0 w-full mb-5 group">
              <label
                htmlFor="department"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Department
              </label>
              <select
                name="department"
                id="department"
                // onChange={handleSignupChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-caribbeanCurrent focus:border-caribbeanCurrent block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-caribbeanCurrent dark:focus:border-caribbeanCurrent"
                onChange={(e) => {
                    setUpdatedUser((prevState) => ({
                      ...prevState,
                      departmentId: e.target.value,
                    }));
                  }}
                  // value={existingUser && existingUser.department ? existingUser.department.name : ""}
                defaultValue={existingUser && existingUser.Department ? existingUser.Department.name : ""}
              >
                <option value="">{existingUser && existingUser.Department ? existingUser.Department.name : "Select Department"}</option>
              {departments.map((department) => (
                <option key={department.id} value={department.id}>
                  {department.name}
                </option>
                  ))}
              </select>
            </div>
            <div className="relative z-0 w-full mb-5 group">
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Email
              </label>
              <input
                type="text"
                id="email"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-caribbeanCurrent focus:border-caribbeanCurrent block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-caribbeanCurrent dark:focus:border-caribbeanCurrent"
                placeholder="Enter email address"
                name="email"
                defaultValue={existingUser && existingUser.email ? existingUser.email : ""}
                onChange={(e) => {
                  setUpdatedUser((prevState) => ({
                    ...prevState,
                    email: e.target.value,
                  }));
                }}
                // value={signupFormValue.lastName}
                // onChange={handleSignupChange}
              />
            </div>
            <button
              type="submit"
              className="text-white bg-caribbeanCurrent hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              {isUpdating ? <Loader size="sm" /> : "Save Changes"}
            </button>
            <p className="text-red">{pageError}</p>

            
          </form>
        </div>
      </div>)}
    </div>
  );
}

export default AdminProfile;
